import { disposables as o } from "../../utils/disposables.js";
import { isIOS as t } from "../../utils/platform.js";
function d() {
  return t() ? { before({ doc: r, d: n, meta: c }) {
    function o$1(a) {
      return c.containers.flatMap((l) => l()).some((l) => l.contains(a));
    }
    n.microTask(() => {
      var s;
      if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
        let t2 = o();
        t2.style(r.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => t2.dispose()));
      }
      let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
      n.addEventListener(r, "click", (t2) => {
        if (t2.target instanceof HTMLElement) try {
          let e = t2.target.closest("a");
          if (!e) return;
          let { hash: f } = new URL(e.href), i = r.querySelector(f);
          i && !o$1(i) && (l = i);
        } catch {
        }
      }, true), n.addEventListener(r, "touchstart", (t2) => {
        if (t2.target instanceof HTMLElement) if (o$1(t2.target)) {
          let e = t2.target;
          for (; e.parentElement && o$1(e.parentElement); ) e = e.parentElement;
          n.style(e, "overscrollBehavior", "contain");
        } else n.style(t2.target, "touchAction", "none");
      }), n.addEventListener(r, "touchmove", (t2) => {
        if (t2.target instanceof HTMLElement) {
          if (t2.target.tagName === "INPUT") return;
          if (o$1(t2.target)) {
            let e = t2.target;
            for (; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth); ) e = e.parentElement;
            e.dataset.headlessuiPortal === "" && t2.preventDefault();
          } else t2.preventDefault();
        }
      }, { passive: false }), n.add(() => {
        var e;
        let t2 = (e = window.scrollY) != null ? e : window.pageYOffset;
        a !== t2 && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({ block: "nearest" }), l = null);
      });
    });
  } } : {};
}
export {
  d as handleIOSLocking
};
